import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class FinancialPeriodsService {
  getAllClosedPeriods(
    organizationId: string,
    propertyId: string,
    optionArgs?: Object,
  ) {
    const defaultOptions = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    const options = { ...defaultOptions, ...optionArgs };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/closed-financialPeriods`,
      options,
    );
  }
  close(organizationId: string, propertyId: string, period: string) {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        period,
      }),
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/financialPeriods/close`,
      options,
    );
  }
}

export default FinancialPeriodsService;
